import React, { useState } from 'react';

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import AnnotatedContentCard from '../partials/aideate/AnnotatedContentCard'
import ModalMarketing from '../components/ModalMarketing'
import SearchForm from '../partials/actions/SearchForm';
import FilterButton from '../components/DropdownFilter';
import CampaignsCard from '../partials/campaigns/CampaignsCard';
import PaginationNumeric from '../components/PaginationNumeric';

import MeetupsThumb01 from '../images/meetups-thumb-01.jpg';
import MeetupsThumb02 from '../images/meetups-thumb-02.jpg';
import MeetupsThumb03 from '../images/meetups-thumb-03.jpg';
import MeetupsThumb04 from '../images/meetups-thumb-04.jpg';
import UserImage01 from '../images/avatar-01.jpg';
import UserImage02 from '../images/avatar-02.jpg';
import UserImage03 from '../images/avatar-03.jpg';
import UserImage04 from '../images/avatar-04.jpg';
import UserImage05 from '../images/avatar-05.jpg';
import UserImage06 from '../images/avatar-06.jpg';

import {useEffect} from "react";
import {Auth} from "aws-amplify";
import {Link, useHistory, useLocation} from "react-router-dom";
import DropdownGeneral from "../components/DropdownGeneral";
import ModalContext from "../components/ModalContext";
import ModalBlank from "../components/ModalBlank"
import CategoryHeatmapCard from "../charts/CategoryHeatmapCard";
import NewsItemContext from "../partials/aideate/NewsItemContext";
import {getDownloadURL, ref as storageRef} from "firebase/storage";
import MissingIcon from "../images/missing.jpg";
import PageCard from "../partials/integrations/hubspot/activity/PageCard";
import IdeateCards from "../partials/aideate/IdeateCards";

function AIdeate() {

  let history = useHistory();
  const location = useLocation()
  const [ authToken, setAuthToken ] = useState(null)
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [ userDetails, setUserDetails ] = useState(null)
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [fintuneModalOpen, setFinetuneModalOpen] = useState(false)
  const [detailModalOpen, setDetailModalOpen] = useState(false)
  const [newsItemCards, setNewsItemCards] = useState([]);
  const [contextURL, setContextURL] = useState('https://');
  const [useWebpageContext, setUseWebpageContext] = useState(false);
  const [ideas, setIdeas] = useState([]);
  const [fetchingIdeas, setFetchingIdeas] = useState(false)
  const [selectedIdea, setSelectedIdea] = useState(null)

  const ctaOptions = [{id: 0, value: 'Admin'},
                      {id: 1, value: 'Awareness'},
                      {id: 2, value: 'Claim'},
                      {id: 3, value: 'Discover'},
                      {id: 4, value: 'Purchase'},
                      {id: 5, value: 'Play'},
                      {id: 6, value: 'Watch'},
                      {id: 7, value: 'Reminder'},
                      {id: 8, value: 'Social'},
                      {id: 9, value: 'Feedback'},
                      {id: 10, value: 'Download'}]
  const urgencyOptions = [{id: 0, value: 'Minutes'},
                          {id: 1, value: 'Hours'},
                          {id: 2, value: 'Days'},
                          {id: 3, value: 'Weeks'},
                          {id: 4, value: 'Holiday'},
                          {id: 5, value: 'Season'},
                          {id: 6, value: 'Indefinitely'},
                          {id: 7, value: 'Until Action'}]
  const toneOptions = [{id: 0, value: 'admiration'},
                        {id: 1, value: 'amusement'},
                        {id: 2, value: 'anger'},
                        {id: 3, value: 'annoyance'},
                        {id: 4, value: 'approval'},
                        {id: 5, value: 'caring'},
                        {id: 6, value: 'confusion'},
                        {id: 7, value: 'curiosity'},
                        {id: 8, value: 'desire'},
                        {id: 9, value: 'disapproval'},
                        {id: 10, value: 'disappointment'},
                        {id: 11, value: 'disugust'},
                        {id: 12, value: 'embarrassment'},
                        {id: 13, value: 'excitement'},
                        {id: 14, value: 'fear'},
                        {id: 15, value: 'gratitude'},
                        {id: 16, value: 'grief'},
                        {id: 17, value: 'joy'},
                        {id: 18, value: 'love'},
                        {id: 19, value: 'nervousness'},
                        {id: 20, value: 'optimism'},
                        {id: 21, value: 'realization'},
                        {id: 22, value: 'relief'},
                        {id: 23, value: 'remorse'},
                        {id: 24, value: 'sadness'},
                        {id: 25, value: 'surprise'},
                        {id: 26, value: 'neutral'}]
  const topicOptions = [{id: 0, value: 'arts and culture'},
                        {id: 1, value: 'world news'},
                        {id: 2, value: 'sports'},
                        {id: 3, value: 'healthy living'},
                        {id: 4, value: 'education'},
                        {id: 5, value: 'media'},
                        {id: 6, value: 'technology and science'},
                        {id: 7, value: 'travel'},
                        {id: 8, value: 'environment'},
                        {id: 9, value: ' style and beauty'},
                        {id: 10, value: 'food and drink'},
                        {id: 11, value: 'religion'},
                        {id: 12, value: 'money'},
                        {id: 13, value: 'business'},
                        {id: 14, value: 'parenting'},
                        {id: 15, value: 'entertainment'},
                        {id: 16, value: 'politics'},
                        {id: 17, value: 'comedy'},
                        {id: 18, value: 'wellness'}]
  
  const [selectedTopic, setSelectedTopic] = useState(topicOptions[0].value);
    const [selectedCTA, setSelectedCTA] = useState(ctaOptions[0].value);
    const [selectedTone, setSelectedTone] = useState(toneOptions[0].value);
    const [selectedUrgency, setSelectedUrgency] = useState(urgencyOptions[0].value);


  useEffect(() => {
    OnLoad();
  }, []);

  function OnLoad() {
    Auth.currentSession().then(response => {
      setAuthToken(response.idToken.jwtToken)
    }).catch( (error) => {
      history.push('/signin')
    });

    if(location!=null) {
      if(location.state==null) {
        history.push('/signin')
      }
      else{
        setUserDetails(location.state.userDetails)
        if('queryParams' in location.state) {
          /*if(location.state.queryParams === 'n=ready')
            setAlertModalState({title: '🎉 Insights Ready', message: 'Insights for your synced integration ✔️ are ready. Check them out now 👀'})*/
        }
      }
    }
    else {
      history.push('/signin')
    }
  }

  async function updateTopic(topic){
    setSelectedTopic(topic)
    try {
      fetchRecentNews(topic, true)
    } catch (e){
      console.log(e)
    }
  }

    const isValidUrl = urlString=> {
        var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
            '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
        return !!urlPattern.test(urlString);
    }

    async function fetchData(url, params) {
        try
        {
            const queryParams = buildParams(params);
            const response = await fetch(`${url}?${queryParams}`);
            return await response.json();
        } catch (e){
            return {}
        }
    }

    function buildParams(params) {
        return Object.entries(params)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
    }

  async function ideate(){
      if(userDetails!=null) {
          const url = 'https://fwva7dyjwowd5umc4wla3vusly0jkjba.lambda-url.eu-west-1.on.aws';
          const params = {client_id: userDetails.clientId,
                            cta: selectedCTA,
                            urgency: selectedUrgency,
                            tone: selectedTone,
                            topic: selectedTopic,
                            website_url: useWebpageContext?contextURL:'',
                            news_item_context: ''};
          const responseData = await fetchData(url, params);
          if('result' in responseData){
              setIdeas([...ideas, ...responseData['result']])
          }
      }
      setFetchingIdeas(false)
  }

  function viewIdeaDetail(idea){
    setSelectedIdea(idea)
    setDetailModalOpen(true)
  }
  
  function updateCTA(val){
    setSelectedCTA(val)
  }

  function updateTone(val){
      setSelectedTone(val)
  }

  function updateUrgency(val){
      setSelectedUrgency(val)
  }

  function lastWeekDate(){
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7).toISOString().split('.')[0];
  }

  function prepKeywordForQuery(keyword){
    return keyword.replace(/\s+/g, "+")
  }

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  async function fetchRecentNews(keyword, startNewList){
    var page = 1
    if(newsItemCards.length>0)
      page = getRandomInt(10)

    fetch("https://api.thenewsapi.com/v1/news/top?language=en&locale=us,ie,uk&page="+page+
        "&api_token="+ process.env.REACT_APP_THE_NEWS_API_TOKEN +
        "&search="+prepKeywordForQuery(keyword)+"&limit=3&published_after="+lastWeekDate())
        .then(res => res.json())
        .then(
            (result) => {
              try{
                console.log(result)
                if('data' in result) {

                  if(startNewList)
                    setNewsItemCards(
                      result.data.map((item, index) => {
                        return (
                            <NewsItemContext
                                id={item.uuid}
                                title={item.title}
                                textContent={item.description}
                                imageURL={item.image_url}
                                published={item.published_at}
                                link={item.url}
                            />
                        );
                      }))
                  else
                    setNewsItemCards([...newsItemCards,
                      result.data.map((item, index) => {
                      return (
                          <NewsItemContext
                              id={item.uuid}
                              title={item.title}
                              textContent={item.description}
                              imageURL={item.image_url}
                              published={item.published_at}
                              link={item.url}
                          />
                      );
                  })])
                }
              } catch (e) {
                console.log('Error getting news: ')
                console.log(e)
                setNewsItemCards([])
              }
            },
            (error) => {
              console.log(error)
              setNewsItemCards([])
            }
        )
  }

  return userDetails!=null?(
    <div className="flex h-screen overflow-hidden">

      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails} />

      {/* Content area */} 
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-full mx-auto">

            {/* Page header */}
            <div className="flex sm:flex sm:justify-between sm:items-center mb-8 max-w-full">

              {/* Left: Title */}
              <div className="mb-4 sm:mb-0">
                <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mr-3"><strong>AI</strong>deate ✨</h1>
              </div>
              <div>
                  {fetchingIdeas?<svg className="animate-spin -ml-1 mr-3 h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg"
                       fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="24" cy="24" r="20" stroke="white"
                              stroke-width="4"></circle>
                      <path className="opacity-75" fill="orange"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>:''}
              </div>
              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                <button onClick={(e) => { e.stopPropagation(); setFinetuneModalOpen(true); }}
                        className="btn bg-yellow-500 hover:bg-yellow-600 text-white">
                    <svg className="w-6 h-6 fill-current shrink-0" viewBox="0 0 20 20">
                        <path d="M10.032,8.367c-1.112,0-2.016,0.905-2.016,2.018c0,1.111,0.904,2.014,2.016,2.014c1.111,0,2.014-0.902,2.014-2.014C12.046,9.271,11.143,8.367,10.032,8.367z M10.032,11.336c-0.525,0-0.953-0.427-0.953-0.951c0-0.526,0.427-0.955,0.953-0.955c0.524,0,0.951,0.429,0.951,0.955C10.982,10.909,10.556,11.336,10.032,11.336z"></path>
                        <path d="M17.279,8.257h-0.785c-0.107-0.322-0.237-0.635-0.391-0.938l0.555-0.556c0.208-0.208,0.208-0.544,0-0.751l-2.254-2.257c-0.199-0.2-0.552-0.2-0.752,0l-0.556,0.557c-0.304-0.153-0.617-0.284-0.939-0.392V3.135c0-0.294-0.236-0.532-0.531-0.532H8.435c-0.293,0-0.531,0.237-0.531,0.532v0.784C7.582,4.027,7.269,4.158,6.966,4.311L6.409,3.754c-0.1-0.1-0.234-0.155-0.376-0.155c-0.141,0-0.275,0.055-0.375,0.155L3.403,6.011c-0.208,0.207-0.208,0.543,0,0.751l0.556,0.556C3.804,7.622,3.673,7.935,3.567,8.257H2.782c-0.294,0-0.531,0.238-0.531,0.531v3.19c0,0.295,0.237,0.531,0.531,0.531h0.787c0.105,0.318,0.236,0.631,0.391,0.938l-0.556,0.559c-0.208,0.207-0.208,0.545,0,0.752l2.254,2.254c0.208,0.207,0.544,0.207,0.751,0l0.558-0.559c0.303,0.154,0.616,0.285,0.938,0.391v0.787c0,0.293,0.238,0.531,0.531,0.531h3.191c0.295,0,0.531-0.238,0.531-0.531v-0.787c0.322-0.105,0.636-0.236,0.938-0.391l0.56,0.559c0.208,0.205,0.546,0.207,0.752,0l2.252-2.254c0.208-0.207,0.208-0.545,0.002-0.752l-0.559-0.559c0.153-0.303,0.285-0.615,0.389-0.938h0.789c0.295,0,0.532-0.236,0.532-0.531v-3.19C17.812,8.495,17.574,8.257,17.279,8.257z M16.747,11.447h-0.653c-0.241,0-0.453,0.164-0.514,0.398c-0.129,0.496-0.329,0.977-0.594,1.426c-0.121,0.209-0.089,0.473,0.083,0.645l0.463,0.465l-1.502,1.504l-0.465-0.463c-0.174-0.174-0.438-0.207-0.646-0.082c-0.447,0.262-0.927,0.463-1.427,0.594c-0.234,0.061-0.397,0.271-0.397,0.514V17.1H8.967v-0.652c0-0.242-0.164-0.453-0.397-0.514c-0.5-0.131-0.98-0.332-1.428-0.594c-0.207-0.123-0.472-0.09-0.646,0.082l-0.463,0.463L4.53,14.381l0.461-0.463c0.169-0.172,0.204-0.434,0.083-0.643c-0.266-0.461-0.467-0.939-0.596-1.43c-0.06-0.234-0.272-0.398-0.514-0.398H3.313V9.319h0.652c0.241,0,0.454-0.162,0.514-0.397c0.131-0.498,0.33-0.979,0.595-1.43c0.122-0.208,0.088-0.473-0.083-0.645L4.53,6.386l1.503-1.504l0.46,0.462c0.173,0.172,0.437,0.204,0.646,0.083c0.45-0.265,0.931-0.464,1.433-0.597c0.233-0.062,0.396-0.274,0.396-0.514V3.667h2.128v0.649c0,0.24,0.161,0.452,0.396,0.514c0.502,0.133,0.982,0.333,1.433,0.597c0.211,0.12,0.475,0.089,0.646-0.083l0.459-0.462l1.504,1.504l-0.463,0.463c-0.17,0.171-0.202,0.438-0.081,0.646c0.263,0.448,0.463,0.928,0.594,1.427c0.061,0.235,0.272,0.397,0.514,0.397h0.651V11.447z"></path>
                    </svg>
                    <span className="hidden xs:block ml-2">Fine-tune</span>
                </button>
                {/* Create campaign button */}
                <button className="btn bg-pink-500 hover:bg-pink-600 text-white" onClick={()=>{setFetchingIdeas(true); ideate();}}>
                    <svg className="w-6 h-6 fill-current shrink-0" viewBox="0 0 20 20">
                        <path d="M3.254,6.572c0.008,0.072,0.048,0.123,0.082,0.187c0.036,0.07,0.06,0.137,0.12,0.187C3.47,6.957,3.47,6.978,3.484,6.988c0.048,0.034,0.108,0.018,0.162,0.035c0.057,0.019,0.1,0.066,0.164,0.066c0.004,0,0.01,0,0.015,0l2.934-0.074c0.317-0.007,0.568-0.271,0.56-0.589C7.311,6.113,7.055,5.865,6.744,5.865c-0.005,0-0.01,0-0.015,0L5.074,5.907c2.146-2.118,5.604-2.634,7.971-1.007c2.775,1.912,3.48,5.726,1.57,8.501c-1.912,2.781-5.729,3.486-8.507,1.572c-0.259-0.18-0.618-0.119-0.799,0.146c-0.18,0.262-0.114,0.621,0.148,0.801c1.254,0.863,2.687,1.279,4.106,1.279c2.313,0,4.591-1.1,6.001-3.146c2.268-3.297,1.432-7.829-1.867-10.101c-2.781-1.913-6.816-1.36-9.351,1.058L4.309,3.567C4.303,3.252,4.036,3.069,3.72,3.007C3.402,3.015,3.151,3.279,3.16,3.597l0.075,2.932C3.234,6.547,3.251,6.556,3.254,6.572z"></path>
                    </svg>
                  <span className="hidden xs:block ml-2">Ideate</span>
                </button>
              </div>
            </div>
              { ideas.length>0?<IdeateCards ideas={ideas} viewIdea={viewIdeaDetail}/>:
                <div className='w-full bg-white shadow-1 p-10 text-center'>
                    <p>Use this space for brainstorming campaign ideas using our helpful generation tool.</p>
                </div>
              }
          </div>
        </main>

      </div>
      <div className="m-1.5">
        {/* Start */}
        {/* Context selection modal */}
        <ModalContext id="context-modal" modalOpen={fintuneModalOpen} setModalOpen={setFinetuneModalOpen}>
          <div className="relative">
            {/*<img className="w-full" src={ModalImage} width="460" height="200" alt="New on Mosaic" />*/}
            {/* Close button */}
            <button className="absolute top-0 right-0 mt-5 mr-5 text-slate-50 hover:text-yellow-500"
                    onClick={(e) => { e.stopPropagation(); setFinetuneModalOpen(false); }}>
              <div className="sr-only">Close</div>
              <svg className="w-4 h-4 fill-current">
                <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
              </svg>
            </button>
          </div>
          <div className="p-5">
            {/* Modal header */}
            <div className="mb-2">
              <div className="text-2xl font-semibold text-slate-800">Fine-tune Campaign</div>
            </div>
            {/* Modal content */}
            <div className="text-sm mb-5">
              {/* Active Integration */}

              {/* Given URL */}
              <div>
                <div className="text-xl text-slate-800">
                    🌐 Webpage context
                </div>
                <div className="flex">
                  <p className="my-auto mr-10">Enter a URL to use as context</p>
                </div>
                  <div className="grid grid-rows-1 grid-cols-2">
                    <div className="relative mt-2 col-span-1">
                      <label htmlFor="url" className="sr-only">URL</label>
                      <input id="url" value={contextURL}
                             onChange={(e) => setContextURL(e.target.value)}
                             className="form-input pl-9 focus:border-slate-300" placeholder="https://" />
                      <div className="absolute inset-0 right-auto group mt-1.5 max-h-10">
                        <svg className="flex-shrink-0 h-6 w-6 mx-2" viewBox="0 0 20 20">
                          <path className="fill-current text-gray-400" d="M10,2.531c-4.125,0-7.469,3.344-7.469,7.469c0,4.125,3.344,7.469,7.469,7.469c4.125,0,7.469-3.344,7.469-7.469C17.469,5.875,14.125,2.531,10,2.531 M10,3.776c1.48,0,2.84,0.519,3.908,1.384c-1.009,0.811-2.111,1.512-3.298,2.066C9.914,6.072,9.077,5.017,8.14,4.059C8.728,3.876,9.352,3.776,10,3.776 M6.903,4.606c0.962,0.93,1.82,1.969,2.53,3.112C7.707,8.364,5.849,8.734,3.902,8.75C4.264,6.976,5.382,5.481,6.903,4.606 M3.776,10c2.219,0,4.338-0.418,6.29-1.175c0.209,0.404,0.405,0.813,0.579,1.236c-2.147,0.805-3.953,2.294-5.177,4.195C4.421,13.143,3.776,11.648,3.776,10 M10,16.224c-1.337,0-2.572-0.426-3.586-1.143c1.079-1.748,2.709-3.119,4.659-3.853c0.483,1.488,0.755,3.071,0.784,4.714C11.271,16.125,10.646,16.224,10,16.224 M13.075,15.407c-0.072-1.577-0.342-3.103-0.806-4.542c0.673-0.154,1.369-0.243,2.087-0.243c0.621,0,1.22,0.085,1.807,0.203C15.902,12.791,14.728,14.465,13.075,15.407 M14.356,9.378c-0.868,0-1.708,0.116-2.515,0.313c-0.188-0.464-0.396-0.917-0.621-1.359c1.294-0.612,2.492-1.387,3.587-2.284c0.798,0.97,1.302,2.187,1.395,3.517C15.602,9.455,14.99,9.378,14.356,9.378"></path>
                        </svg>
                      </div>
                        {isValidUrl(contextURL)?<div className="flex flex-wrap items-center mt-3 w-full">
                            <div className="m-3">
                                {/* Start */}
                                <label className="flex items-center">
                                    <input type="checkbox" className="form-checkbox cursor-pointer text-yellow-500"
                                           onChange={()=>setUseWebpageContext(!useWebpageContext)}
                                           checked={useWebpageContext}/>
                                    <span className="text-sm ml-2" >Use this webpage for context</span>
                                </label>
                                {/* End */}
                            </div>
                            <p className="text-justify">If you check the box, EmPushy will analyse the content of the selected web page and
                                use it as context for crafting campaigns ✍️. For example, this is particularly useful,
                                if you wish to launch a campaign that ultimately wishes to navigate
                                subscribers to this particular page 🎯. Depending on the call-to-action, EmPushy crafts
                                the optimal campaign to achieve the goal, using any existing content you have on the page
                                as context 🧠.</p>
                        </div>:''}
                        {/*<button className="btn-sm bg-yellow-500 hover:bg-yellow-600 text-white ml-3" onClick={fetchWebsite}>
                            Fetch
                        </button>*/}
                    </div>
                      <div className="col-span-1 px-5">
                          {isValidUrl(contextURL)?<PageCard pageData={{'url': contextURL}} viewDetail={null}/>:''}
                      </div>
                  </div>
              </div>
              <hr className="my-5" />
                <div>
                  <div className="text-xl text-slate-800">
                      🕺 Style & features
                  </div>
                  <div className="flex mb-3">
                      <p>Select an applicable tone, call-to-action and level of urgency for the campaign.</p>
                  </div>
                  <div className="grid grid-rows-1 grid-cols-3 w-full">
                      {/* Tone */}
                      <div className="flex flex-col items-center">
                          <p>Tone</p>
                          <DropdownGeneral options={toneOptions} selectedFilter={'Market'}
                                           updateFunc={updateTone}/>
                      </div>
                      {/* Urgency */}
                      <div className="flex flex-col items-center">
                          <p>Urgency</p>
                          <DropdownGeneral options={urgencyOptions} selectedFilter={'Market'}
                                       updateFunc={updateUrgency}/>
                      </div>
                      {/* CTA */}
                      <div className="flex flex-col items-center">
                          <p>Call-to-action</p>
                          <DropdownGeneral options={ctaOptions} selectedFilter={'Market'}
                                       updateFunc={updateCTA}/>
                      </div>
                  </div>
                </div>
              <hr className="my-5"/>
              {/* Trending stories */}
              <div>
                <div className="text-xl text-slate-800">
                    📰 Topic
                </div>
                <div className="flex">
                  <p className="my-auto mr-10 mb-2">Select a relevant topic. Then, if you wish, select an applicable news
                    item as/if they appear</p>
                </div>
                <DropdownGeneral options={topicOptions} selectedFilter={selectedTopic}
                                 updateFunc={updateTopic}/>
                <div className="flex mt-2">
                  <div className={`${newsItemCards.length>0?'visible':'hidden'} rounded-sm w-full`}>
                    {newsItemCards}
                  </div>
                </div>
                <div>
                  {newsItemCards.length>0?<button className="w-full btn-sm bg-pink-400 hover:bg-pink-500 text-white"
                           onClick={() => fetchRecentNews(selectedTopic, false)}>
                    Load more
                  </button>:''}
                </div>
              </div>

            </div>
            {/* Modal footer */}
            <div className="flex flex-wrap justify-end space-x-2">
              <button className="btn-sm bg-yellow-500 hover:bg-yellow-600 text-white"
                      onClick={(e) => { e.stopPropagation();
                          setFinetuneModalOpen(false); }}>
                Save
              </button>
            </div>
          </div>
        </ModalContext>
        {/* End */}
      </div>
      <div className="m-1.5">
          <ModalMarketing id="detail-modal" modalOpen={detailModalOpen} setModalOpen={setDetailModalOpen}
                          maxWidth={"max-w-5xl"}   height={"full"}>
                <div className="relative">
                    {/*<img className="w-full" src={ModalImage} width="460" height="200" alt="New on Mosaic" />*/}
                    {/* Close button */}
                    <button className="absolute top-0 right-0 mt-5 mr-5 text-slate-50 hover:text-yellow-500"
                            onClick={(e) => { e.stopPropagation(); setDetailModalOpen(false); }}>
                        <div className="sr-only">Close</div>
                        <svg className="w-4 h-4 fill-current">
                            <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
                        </svg>
                    </button>
                </div>
                <div className="p-5">
                    {/* Modal header */}
                    <div className="mb-2">
                        <div className="text-2xl font-semibold text-slate-800">Fine-tune Campaign</div>
                    </div>
                    {/* Modal content */}
                    <div className="text-sm mb-5">
                        {selectedIdea!=null?selectedIdea.checklist:''}
                        {selectedIdea!=null?<AnnotatedContentCard idea={selectedIdea}/>:''}
                    </div>
                    {/* Modal footer */}
                    <div className="flex flex-wrap justify-end space-x-2">
                        <button className="btn-sm bg-yellow-500 hover:bg-yellow-600 text-white"
                                onClick={(e) => { e.stopPropagation();
                                    setDetailModalOpen(false); }}>
                            Done
                        </button>
                    </div>
                </div>
            </ModalMarketing>
      </div>
    </div>
  ):''
}

export default AIdeate;